export const sidebarAnimation = {
  open: {
    opacity: [0, 1],
  },
  closed: {
    opacity: 0,
  },
};
